import { useMemo } from 'react';

import { useStarterDashboardV2PageFcm } from 'src/app/pages/starterDashboardV2/pageContext';
import { useLocale } from 'src/app/shared/hooks/l10n';

type UseSocialMediaContentReturn = ModelHookResult<{ newModuleEnabled: boolean }>;

export function useSocialMediaContent(): UseSocialMediaContentReturn {
	const { starterDashboardNewAssetsConfig } = useStarterDashboardV2PageFcm();

	const locale = useLocale();
	const newAssetsEnabled = useMemo(() => {
		const disabled = { enabled: false } as const;
		if (!starterDashboardNewAssetsConfig) return disabled;
		if (!starterDashboardNewAssetsConfig.enabled) return disabled;
		if (!starterDashboardNewAssetsConfig.locales.includes(locale)) return disabled;

		return { enabled: true } as const;
	}, [locale, starterDashboardNewAssetsConfig]);

	return {
		data: {
			newModuleEnabled: newAssetsEnabled.enabled,
		},
	};
}
